
const digest = '0e513e8fe7a41a07fa93f5143fed468553af9b15b2f55545c8d74bb289158993';
const classes = {"wrapper":"_wrapper_kn3rt_1","date":"_date_kn3rt_14","file":"_file_kn3rt_19","name":"_name_kn3rt_25","savedBy":"_savedBy_kn3rt_31","itemControls":"_itemControls_kn3rt_39","link":"_link_kn3rt_45"};
const css = `._wrapper_kn3rt_1 {
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 24px 19px;
  gap: 28px;
  border: 1px solid #eaedf3;
  border-top: 0;
  background: #ffffff;
}
._wrapper_kn3rt_1:first-of-type {
  border-top: 1px solid #eaedf3;
}
._wrapper_kn3rt_1 ._date_kn3rt_14 {
  font-size: 14px;
  color: #000000;
  min-width: 110px;
}
._wrapper_kn3rt_1 ._file_kn3rt_19 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 6px;
}
._wrapper_kn3rt_1 ._file_kn3rt_19 ._name_kn3rt_25 {
  font-weight: 500;
  font-size: 14px;
  color: #1665d8;
  text-decoration: underline;
}
._wrapper_kn3rt_1 ._file_kn3rt_19 ._savedBy_kn3rt_31 {
  font-size: 12px;
  color: #9ea0a5;
}
._wrapper_kn3rt_1 ._file_kn3rt_19 ._savedBy_kn3rt_31 span {
  color: #000;
  font-weight: 500;
}
._wrapper_kn3rt_1 ._itemControls_kn3rt_39 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
}
._wrapper_kn3rt_1 ._itemControls_kn3rt_39 ._link_kn3rt_45 {
  font-weight: 500;
  font-size: 14px;
  color: #1665d8;
  text-decoration: underline;
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  